import { useMemo } from 'react';
import { useBootstrapApiBase } from '../api';
import { CREDIT_USAGE_DISPLAY_ORDER, CreditUsageTitle } from '../constants';
import { CreditUsage, CreditUsageType } from '../definition';

const creditUsageDisplayRank = (key: CreditUsageType) => {
  const index = CREDIT_USAGE_DISPLAY_ORDER.indexOf(key);
  return index === -1 ? CREDIT_USAGE_DISPLAY_ORDER.length : index;
};

interface UseCreditUsageItemsReturn {
  items: CreditUsage[];
  isLoading: boolean;
}

const EMPTY_ITEMS: CreditUsage[] = [];

export function useCreditUsageItems(
  filterArr?: CreditUsageType[]
): UseCreditUsageItemsReturn {
  const api = useBootstrapApiBase();
  const cost = api.data?.cost;

  const items = useMemo<CreditUsage[]>(() => {
    if (!cost) return EMPTY_ITEMS;
    return (Object.keys(cost) as CreditUsageType[])
      .filter((key) => key in CreditUsageTitle)
      .filter((key) => (filterArr ? filterArr.includes(key) : true))
      .sort((a, b) => creditUsageDisplayRank(a) - creditUsageDisplayRank(b))
      .map((key) => ({
        credit: cost[key],
        title: CreditUsageTitle[key],
        type: key,
      }));
  }, [cost, filterArr]);

  return { items, isLoading: api.isLoading };
}
